var _rect, _rect2, _g, _rect3, _rect4, _g2, _rect5, _rect6, _g3, _g4, _g5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionsCategoriesEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 90,
    viewBox: "0 0 204 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 2,
    width: 136,
    height: 40,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 18,
    y: 10,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#4494FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_644:2675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7142 17.7147H31.7213C31.5339 17.7139 31.3544 17.6395 31.2213 17.5076L30.207 16.4933C30.074 16.3613 29.8944 16.2869 29.707 16.2861H24.2856C23.4966 16.2861 22.857 16.9257 22.857 17.7147V26.2861C22.857 27.0751 23.4966 27.7147 24.2856 27.7147H35.7142C36.5032 27.7147 37.1428 27.0751 37.1428 26.2861V19.1433C37.1428 18.3543 36.5032 17.7147 35.7142 17.7147Z",
    fill: "#4494FF"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 50,
    width: 136,
    height: 40,
    rx: 8,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 50,
    y: 58,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#4494FF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_644:2675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.7144 65.7147H63.7216C63.5342 65.7139 63.3546 65.6395 63.2216 65.5076L62.2073 64.4933C62.0742 64.3613 61.8947 64.2869 61.7073 64.2861H56.2858C55.4969 64.2861 54.8573 64.9257 54.8573 65.7147V74.2861C54.8573 75.0751 55.4969 75.7147 56.2858 75.7147H67.7144C68.5034 75.7147 69.143 75.0751 69.143 74.2861V67.1433C69.143 66.3543 68.5034 65.7147 67.7144 65.7147Z",
    fill: "#4494FF"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 18,
    width: 80,
    height: 8,
    rx: 2,
    fill: "#C2CFE0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 66,
    width: 80,
    height: 8,
    rx: 2,
    fill: "#C2CFE0"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_644:2675)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 50,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8333 65.5837V66.417C23.8333 66.6471 23.6468 66.8337 23.4167 66.8337H18.8333V71.417C18.8333 71.6471 18.6468 71.8337 18.4167 71.8337H17.5833C17.3532 71.8337 17.1667 71.6471 17.1667 71.417V66.8337H12.5833C12.3532 66.8337 12.1667 66.6471 12.1667 66.417V65.5837C12.1667 65.3535 12.3532 65.167 12.5833 65.167H17.1667V60.5837C17.1667 60.3535 17.3532 60.167 17.5833 60.167H18.4167C18.6468 60.167 18.8333 60.3535 18.8333 60.5837V65.167H23.4167C23.6468 65.167 23.8333 65.3535 23.8333 65.5837Z",
    fill: "#4494FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter1_f_644:2675)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 2,
    width: 24,
    height: 24,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.375 13.6875V14.3125C178.375 14.4851 178.235 14.625 178.062 14.625H174.625V18.0625C174.625 18.2351 174.485 18.375 174.312 18.375H173.688C173.515 18.375 173.375 18.2351 173.375 18.0625V14.625H169.938C169.765 14.625 169.625 14.4851 169.625 14.3125V13.6875C169.625 13.5149 169.765 13.375 169.938 13.375H173.375V9.9375C173.375 9.76491 173.515 9.625 173.688 9.625H174.312C174.485 9.625 174.625 9.76491 174.625 9.9375V13.375H178.062C178.235 13.375 178.375 13.5149 178.375 13.6875Z",
    fill: "#4494FF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_f_644:2675)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 50,
    width: 16,
    height: 16,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.917 57.7913V58.208C196.917 58.3231 196.823 58.4163 196.708 58.4163H194.417V60.708C194.417 60.8231 194.323 60.9163 194.208 60.9163H193.792C193.677 60.9163 193.583 60.8231 193.583 60.708V58.4163H191.292C191.177 58.4163 191.083 58.3231 191.083 58.208V57.7913C191.083 57.6763 191.177 57.583 191.292 57.583H193.583V55.2913C193.583 55.1763 193.677 55.083 193.792 55.083H194.208C194.323 55.083 194.417 55.1763 194.417 55.2913V57.583H196.708C196.823 57.583 196.917 57.6763 196.917 57.7913Z",
    fill: "#4494FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_644:2675",
    x: 0,
    y: 48,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_644:2675"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_644:2675",
    x: 160,
    y: 0,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_644:2675"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_644:2675",
    x: 184,
    y: 48,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_644:2675"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_644:2675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1429,
    height: 17.1429,
    fill: "white",
    transform: "translate(21.4285 13.4287)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_644:2675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1429,
    height: 17.1429,
    fill: "white",
    transform: "translate(53.4287 61.4287)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsCategoriesEmpty);
export default __webpack_public_path__ + "static/media/transactions-categories-empty.1e252f5c.svg";
export { ForwardRef as ReactComponent };